export default __webpack_public_path__ + "static/media/notes.3fc57abd.svg";